// =========================================================================================@@
// Last Updated Date: Mar 15, 2023
// Last Updated By: Steven Yuen
// Status Level: 2
// ===========================================================================================

import React, { useEffect } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import { organizationsWithCover } from 'config/constants/themeDefaults/layoutBox'
import HomeCover from 'src/sites/kits/Home/components/Cover'
import { useOrganization } from 'src/core/graphql/hooks'
import { useGlobalState } from 'src/sites/state'
import Nav from '~/components/MainMenu/Nav'
import Logo from '~/components/MainMenu/Logo'
import MainMenuMobile from '~/components/MainMenu/Mobile'
import SearchInput from '~/components/MainMenu/SearchInput'
// import AccountBlock from '~/components/MainMenu/SidebarAccountBlock'
import ActionBlock from '~/components/MainMenu/SidebarActionBlock'

const CommunityLayout = ({ children }) => {
   const { theme } = useGlobalState()
   const { organization } = useOrganization()
   // const hasLogo = organization[theme.globalNavLogoFieldName]?.file
   const hasHomeCover = organizationsWithCover.includes(organization.slug)
   // const homeCoverIsVisible = match.url === '/' && match.isExact

   useEffect(() => {
      document.body.style.background = 'var(--bodyBackgroundColor)'
   }, [theme.tmpBackgroundColor])

   return (
      <>
         <MainMenuMobile />
         {hasHomeCover && <HomeCover />}
         <View
            display="flex"
            width="100%"
            className="col-container">
            <View
               flex="0 0 auto"
               className="col-3">
               <View
                  width="100%"
                  height="100vh"
                  padding="0px 24px">
                  <View
                     display="flex"
                     alignItems="center"
                     height="116px"
                     paddingLeft="8px"
                     paddingRight="16px"
                     paddingBottom="8px"
                     borderBottom="1px solid var(--logoBlockLineColor)"
                     width="100%">
                     <Logo maxHeight="60px" maxWidth="100%" />
                  </View>
                  <View marginBottom2="16px" marginBottom="16px">
                     <SearchInput />
                  </View>
                  <Nav
                     buttonLineColor={theme.tmpMainMenuLineColor}
                     buttonTextColor={theme.tmpMainMenuButtonTextColor}
                     orientation="vertical"
                  />
               </View>
            </View>
            <View
               flex="0 0 auto"
               className="col-6"
               minHeight="100vh"
               borderLeft="1px solid var(--primaryLineColor)"
               borderRight="1px solid var(--primaryLineColor)">
               {children}
            </View>
            <View
               flex="0 0 auto"
               className="col-3">
               <View
                  width="100%"
                  height="100vh"
                  padding="40px var(--gutter)">
                  <ActionBlock />
                  {'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Turpis egestas pretium aenean pharetra. Orci eu lobortis elementum nibh tellus molestie. Vulputate dignissim suspendisse in est. Vel pharetra vel turpis nunc. Malesuada nunc vel risus commodo. Nisi vitae suscipit tellus mauris. Posuere morbi leo urna molestie at elementum eu. Urna duis convallis convallis tellus. Urna molestie at elementum eu. Nunc sed blandit libero volutpat.'}
                  <View display="none[e-f]">D</View>
                  <View display="none[d]">E+</View>
               </View>
            </View>
         </View>
      </>
   )
}

CommunityLayout.propTypes = {
   children: PropTypes.node.isRequired
}

export default CommunityLayout
